// extracted by mini-css-extract-plugin
module.exports =  {"label":"_734d14f77d--label--USu4T","desktop":"_734d14f77d--desktop--lpXbM","checkbox":"_734d14f77d--checkbox--XzOLn"};